module.exports = __webpack_public_path__ + "img/Historico.b25cb6e0.png";